import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import React, {useState} from 'react'
import {IOwner, ownerInitValues as initialValues} from '../../models/OwnerModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import InputMask from 'react-input-mask'
import axios from 'axios'
import {useIntl} from 'react-intl'
import HeaderCard from '../../../../../../components/Forms/HeaderCard'
import {Input} from '../../../../../../components/Forms/Input'

const API_URL = process.env.REACT_APP_API_URL || 'api'

const ownerSchema = Yup.object().shape({
  name: Yup.string().required('Campo obrigatório'),
  // issue_organs: Yup.number().required('Campo obrigatório'),
  // telephone: Yup.string().required('Campo obrigatório'),
  //descripton: Yup.string().required('Campo obrigatório'),
  // email: Yup.string().required('Campo obrigatório'),
})

const FormOwnerAdd: React.FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const resp = localStorage.getItem('auth_storage')
  let token = ''
  if (resp) {
    token = JSON.parse(resp)
  }
  let config = {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  }

  // const [data, setData] = useState<IProduct>()
  // const updateData = (fieldsToUpdate: Partial<IProduct>): void => {
  //   const updatedData = Object.assign(data, fieldsToUpdate)
  //   setData(updatedData)
  // }

  const formik = useFormik<IOwner>({
    initialValues,
    validationSchema: ownerSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        await axios.post(API_URL + '/sgt/v1/owners', values, config)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'OWNER.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/owners')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'OWNER.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 1500,
        })

        setLoading(false)
      }
    },
  })
  function resetInputs() {
    formik.resetForm()
  }

  return (
    <div className='card card-custom mt-n8'>
      {/* Component Header de Cadastros. */}
      <HeaderCard
        buttonBack={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})}
        title={intl.formatMessage({id: 'OWNER.ADD_TITLE'})}
        routeBack='/owners'
      />

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            {/* INICIO NOME */}
            <Input
              title={intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
              placeholder={intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
              {...formik.getFieldProps('name')}
              required
            />
            {/* FIM NOME */}

            {/* INÍCIO CNPJ ------------------------------*/}
            <div className='row mb-3'>
              <label className='col-lg-2 col-form-label fw-bold fs-6'>
                <span className='required'>{intl.formatMessage({id: 'COMMON.INPUT_CNPJ'})}</span>
              </label>

              <div className='col-lg-10 fv-row'>
                <InputMask
                  mask={'99.999.999/9999-99'}
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder={intl.formatMessage({id: 'COMMON.INPUT_CNPJ'})}
                  {...formik.getFieldProps('document')}
                />
                {formik.touched.document && formik.errors.document && (
                  <div className='fv-plugins-message-container text-danger'>
                    <div className='fv-help-block'>{formik.errors.document}</div>
                  </div>
                )}
              </div>
            </div>
            {/* FIM CNPJ ------------------------------*/}

            {/* INICIO Email */}
            <Input
              title={intl.formatMessage({id: 'COMMON.INPUT_EMAIL'})}
              placeholder={intl.formatMessage({id: 'COMMON.INPUT_EMAIL'})}
              {...formik.getFieldProps('email')}
            />
            {/* FIM Email */}

            {/* INICIO Informações adicionais */}
            <Input
              title={intl.formatMessage({id: 'COMMON.INPUT_ADDITIONAL_DATA'})}
              placeholder={intl.formatMessage({id: 'COMMON.INPUT_ADDITIONAL_DATA'})}
              {...formik.getFieldProps('additional_data')}
            />
            {/* FIM Informações adicionais */}

            {/* INICIO Banco */}
            <Input
              title={intl.formatMessage({id: 'COMMON.INPUT_BANK'})}
              placeholder={intl.formatMessage({id: 'COMMON.INPUT_BANK'})}
              {...formik.getFieldProps('bank')}
            />
            {/* FIM Banco */}

            {/* INICIO Agência */}
            <Input
              title={intl.formatMessage({id: 'COMMON.INPUT_AGENCY'})}
              placeholder={intl.formatMessage({id: 'COMMON.INPUT_AGENCY'})}
              {...formik.getFieldProps('agency')}
            />
            {/* FIM Agência */}

            {/* INICIO Conta */}
            <Input
              title={intl.formatMessage({id: 'COMMON.INPUT_ACCOUNT'})}
              placeholder={intl.formatMessage({id: 'COMMON.INPUT_ACCOUNT'})}
              {...formik.getFieldProps('account')}
            />
            {/* FIM Conta */}

            {/* INICIO Tipo de Conta */}
            <div className='row mb-3'>
              <label className='col-lg-2 col-form-label fw-bold fs-6'>
                <span>{intl.formatMessage({id: 'COMMON.INPUT_ACCOUNT_TYPE'})}</span>
              </label>

              <div className='col-lg-10 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg fw-bold'
                  {...formik.getFieldProps('account_type')}
                >
                  <option value=''>{intl.formatMessage({id: 'COMMON.INPUT_ACCOUNT_TYPE'})}</option>
                  <option value='checking_account'>
                    {intl.formatMessage({id: 'COMMON.INPUT_ACCOUNT_TYPE_CHECKING'})}
                  </option>
                  <option value='saving_account'>
                    {intl.formatMessage({id: 'COMMON.INPUT_ACCOUNT_TYPE_CHECKING_CONJOINT'})}
                  </option>
                  <option value='checking_account_conjoint'>
                    {intl.formatMessage({id: 'COMMON.INPUT_ACCOUNT_TYPE_SAVING'})}
                  </option>
                  <option value='saving_account_conjoint'>
                    {intl.formatMessage({id: 'COMMON.INPUT_ACCOUNT_TYPE_SAVING_CONJOINT'})}
                  </option>
                </select>
                {formik.touched.account_type && formik.errors.account_type && (
                  <div className='fv-plugins-message-container text-danger'>
                    <div className='fv-help-block'>{formik.errors.account_type}</div>
                  </div>
                )}
              </div>
            </div>
            {/* FIM Tipo de Conta */}

            {/* INICIO Cidade */}
            <Input
              title={intl.formatMessage({id: 'COMMON.INPUT_CITY'})}
              placeholder={intl.formatMessage({id: 'COMMON.INPUT_CITY'})}
              {...formik.getFieldProps('city')}
            />
            {/* FIM Cidade */}

            {/* INICIO HTML ESTADO */}
            <div className='row mb-3'>
              <label className='col-lg-2 col-form-label fw-bold fs-6'>
                <span>{intl.formatMessage({id: 'COMMON.INPUT_STATE'})}</span>
              </label>

              <div className='col-lg-10 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg fw-bold'
                  {...formik.getFieldProps('state')}
                >
                  <option value=''>{intl.formatMessage({id: 'COMMON.INPUT_STATE_MSG'})}</option>
                  <option value='AC'>Acre</option>
                  <option value='AL'>Alagoas</option>
                  <option value='AP'>Amapá</option>
                  <option value='AM'>Amazonas</option>
                  <option value='BA'>Bahia</option>
                  <option value='CE'>Ceará</option>
                  <option value='DF'>Distrito Federal</option>
                  <option value='ES'>Espírito Santo</option>
                  <option value='GO'>Goiás</option>
                  <option value='MA'>Maranhão</option>
                  <option value='MT'>Mato Grosso</option>
                  <option value='MS'>Mato Grosso do Sul</option>
                  <option value='MG'>Minas Gerais</option>
                  <option value='PA'>Pará</option>
                  <option value='PB'>Paraíba</option>
                  <option value='PR'>Paraná</option>
                  <option value='PE'>Pernambuco</option>
                  <option value='PI'>Piauí</option>
                  <option value='RJ'>Rio de Janeiro</option>
                  <option value='RN'>Rio Grande do Norte</option>
                  <option value='RS'>Rio Grande do Sul</option>
                  <option value='RO'>Rondônia</option>
                  <option value='RR'>Roraima</option>
                  <option value='SC'>Santa Catarina</option>
                  <option value='SP'>São Paulo</option>
                  <option value='SE'>Sergipe</option>
                  <option value='TO'>Tocantins</option>
                </select>
                {formik.touched.state && formik.errors.state && (
                  <div className='fv-plugins-message-container text-danger'>
                    <div className='fv-help-block'>{formik.errors.state}</div>
                  </div>
                )}
              </div>
            </div>
            {/* FIM ESTADO */}

            {/* INICIO Logradouro */}
            <Input
              title={intl.formatMessage({id: 'COMMON.INPUT_ADDRESS'})}
              placeholder={intl.formatMessage({id: 'COMMON.INPUT_ADDRESS'})}
              {...formik.getFieldProps('street_name')}
            />
            {/* FIM Logradouro */}

            {/* INICIO Número */}
            <Input
              title={intl.formatMessage({id: 'COMMON.INPUT_NUMBER'})}
              placeholder={intl.formatMessage({id: 'COMMON.INPUT_NUMBER'})}
              {...formik.getFieldProps('number')}
            />
            {/* FIM Número */}

            {/* INICIO Bairro */}
            <Input
              title={intl.formatMessage({id: 'COMMON.INPUT_DISTRICT'})}
              placeholder={intl.formatMessage({id: 'COMMON.INPUT_DISTRICT'})}
              {...formik.getFieldProps('district')}
            />
            {/* FIM Bairro */}

            {/* INICIO Complemento */}
            <Input
              title={intl.formatMessage({id: 'COMMON.INPUT_COMPLEMENT'})}
              placeholder={intl.formatMessage({id: 'COMMON.INPUT_COMPLEMENT'})}
              {...formik.getFieldProps('complement')}
            />
            {/* FIM Complemento */}

            {/* INICIO CEP */}
            <div className='row mb-3'>
              <label className='col-lg-2 col-form-label required fw-bold fs-6'>
                <span>{intl.formatMessage({id: 'COMMON.INPUT_ZIPCODE'})}</span>
              </label>

              <div className='col-lg-10 fv-row'>
                <InputMask
                  mask='99999-999'
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder={intl.formatMessage({id: 'COMMON.INPUT_ZIPCODE'})}
                  {...formik.getFieldProps('zip_code')}
                />
                {formik.touched.zip_code && formik.errors.zip_code && (
                  <div className='fv-plugins-message-container text-danger'>
                    <div className='fv-help-block'>{formik.errors.zip_code}</div>
                  </div>
                )}
              </div>
            </div>
            {/* FIM zip_code */}

            <div className='d-flex justify-content-end py-6'>
              <button type='submit' className='btn btn-primary' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button type='reset' onClick={resetInputs} className='btn btn-secondary  mx-2'>
                {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormOwnerAdd}
